import React from "react";

const StatusCard = ({
  index,
  title,
  count,
  totalObjects,
  cardStatus,
  status,
  handleCardClick,
}) => {
  const colors = ["#003366", "#fc8716", "#fccb02", "#8dbe46"];
  const percent =
    totalObjects > 0 ? Math.round((count / totalObjects) * 100) : 0;
  return (
    <div className={`${cardStatus === status ? "kpi-card-active" : "kpi-card"}`} onClick={() => handleCardClick(cardStatus)}>
      <h2 className="kpi-title">{title}</h2>
      <p className="text-2xl font-bold mt-2" style={{ color: colors[index] }}>
        {count}
      </p>
      <span className="kpi-percentage" style={{ fontSize: "12px", color: "#9ca3af" }}>
        {`${index === 0 ? "Objects configured" : percent + "% of total"}`}
      </span>
    </div>
  );
};

export default StatusCard;
